import {Grid, Typography} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import {i18n} from 'src/shared/config'

import * as classes from './NoAddressPlaceholder.classes'

type Props = {
  isValid?: boolean
}

export const NoAddressPlaceholder = memo<Props>(function NoAddressPlaceholder({isValid = true}) {
  return (
    <Grid alignItems="center" className={classes.root} direction="column" container>
      <Typography
        color={isValid ? 'main' : 'error'}
        Component={Grid}
        group="normal"
        thickness="medium"
        variant="body2"
        item
      >
        {i18n('cargo.create.offers.placeholder.title', 'Укажите адреса')}
      </Typography>
      <Typography
        color={isValid ? 'minor' : 'error'}
        Component={Grid}
        group="tight"
        thickness="regular"
        variant="caption1"
      >
        {i18n('cargo.create.offers.placeholder.subtitle', 'Здесь появятся доступные варианты доставки')}
      </Typography>
    </Grid>
  )
})
